import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=8cac731a&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=ts"
export * from "./TeamCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cac731a",
  null
  
)

export default component.exports